module.exports = __webpack_public_path__ + "static/img/no_data.3cfa894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_data.png
// module id = Z7F1
// module chunks = 75